export default "<app-connexion-layout></app-connexion-layout>\r\n";